import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

type NoMatchPageProps = {
  children?: ReactNode;
  subTitle?: ReactNode;
};

const HomeButton = () => {
  const navigate = useNavigate();

  return (
    <Button type="primary" onClick={() => navigate('/')}>
      Back Home
    </Button>
  );
};

export const NotFoundPage = ({
  children = <HomeButton />,
  subTitle = 'Sorry, the page you visited does not exist.',
}: NoMatchPageProps) => <Result status="404" title="404" subTitle={subTitle} extra={children} />;
